export const enum FetchErrorType {
  NetworkError = 0,
  BadStatus = 1,
  Internal = 2,
  Aborted = 3,
  ServerErrror = 4,
}

export class FetchError<Cause = unknown> {
  type: FetchErrorType;
  status: number | null;
  cause: Cause | null;
  name: string;

  constructor(type: FetchErrorType, status?: number, cause?: Cause) {
    this.type = type;
    this.status = status ?? null;
    this.cause = cause ?? null;
    switch (type) {
      case FetchErrorType.Aborted:
        this.name = "AbortError";
        break;
      case FetchErrorType.ServerErrror:
        this.name = "FetchServerError";
        break;
      case FetchErrorType.NetworkError:
        this.name = "FetchNetworkError";
        break;
      default:
        this.name = "FetchError";
    }
  }
  get message(): string {
    switch (this.type) {
      case FetchErrorType.NetworkError:
        return "Невозможно подключиться к серверу";
      case FetchErrorType.BadStatus:
        if (this.status === 403) {
          return "Недостаточно прав для выполнения операции";
        }
        return `Ошибка сервера [${this.status}]`;
      case FetchErrorType.Aborted:
        return `Загрузка была прервана`;
    }
    return `Внутренняя ошибка`;
  }
}

// TODO: document and make normal tyes
export class UnprocessableEntityError extends FetchError {
  errors: Record<string, string>;

  constructor(data: { errors: Record<string, string[]>}) {
    super(FetchErrorType.BadStatus, 422, null);
    const dataErrors = data.errors;
    const errors = {} as typeof this.errors;
    for (const error in dataErrors) {
      errors[error] = dataErrors[error][0];
    }
    this.errors = errors;
  }
}
